import { Alert, Slide } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";

const StyledAlertContainer = styled("div")(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(12),
  right: theme.spacing(2),
  zIndex: theme.zIndex.snackbar,
  maxWidth: "400px",
  minWidth: "300px",
}));

const StyledAlert = styled(Alert)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  boxShadow: "0 8px 24px rgba(90, 100, 119, 0.3)",
  backdropFilter: "blur(10px)",
  "& .MuiAlert-icon": {
    alignItems: "center",
  },
  "& .MuiAlert-message": {
    fontWeight: 500,
    fontSize: "1rem",
  },
  "&.MuiAlert-filledSuccess": {
    background: "linear-gradient(135deg, #4caf50 0%, #45a049 100%)",
  },
  "&.MuiAlert-filledError": {
    background: "linear-gradient(135deg, #f44336 0%, #d32f2f 100%)",
  },
  "&.MuiAlert-filledWarning": {
    background: "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",
  },
  "&.MuiAlert-filledInfo": {
    background: "linear-gradient(135deg, #2196f3 0%, #1976d2 100%)",
  },
}));

interface Props {
  type: "success" | "error" | "warning" | "info";
  message?: string;
  show?: boolean;
}

export const AlertComponent = ({ type, message, show = true }: Props) => {
  const defaultMessages = {
    success: "Saved Successfully",
    error: "An error has occurred",
    warning: "Warning: Please check your input",
    info: "Information updated",
  };

  return (
    <Slide direction="left" in={show} mountOnEnter unmountOnExit timeout={300}>
      <StyledAlertContainer>
        <StyledAlert variant="filled" severity={type}>
          {message || defaultMessages[type]}
        </StyledAlert>
      </StyledAlertContainer>
    </Slide>
  );
};
